<template>
  <el-container class="admin-layout">
    <!-- 左侧导航栏 -->
    <el-aside class="sidebar">
      <!-- 系统logo区域 -->
      <div class="sidebar-logo">
        <el-icon class="logo-icon"><UserFilled /></el-icon>
        <span class="logo-text">基础配置</span>
      </div>

      <!-- 导航菜单 -->
      <el-menu
        default-active="1"
        class="sidebar-menu"
        background-color="transparent"
        text-color="#b0c8e8"
        active-text-color="#00ccff"
        @select="handleMenuSelect"
      >
        <el-menu-item index="1">
          <span slot="title">设备管理</span>
        </el-menu-item>
        <el-menu-item index="2">
          <span slot="title">点位管理</span>
        </el-menu-item>
        <el-menu-item index="3">
          <span slot="title">气体阈值管理</span>
        </el-menu-item>
        <el-menu-item index="5">
          <span slot="title">通知配置</span>
        </el-menu-item>
        <el-menu-item index="6">
          <span slot="title">区域管理</span>
        </el-menu-item>
        <el-menu-item index="4">
          <span slot="title">用户管理</span>
        </el-menu-item>
        <!-- 新增通知配置菜单 -->
      </el-menu>
    </el-aside>

    <!-- 右侧内容区域 -->
    <el-container class="main-container">
      <!-- 内容主体 -->
      <el-main class="content-body">
        <!-- 人脸库管理页面 -->
        <div v-if="currentMenu === '1'" class="face-library-page">
          <Monitor></Monitor>
        </div>

        <!-- 设备管理页面 -->
        <div v-if="currentMenu === '2'" class="device-page">
          <Point></Point>
        </div>

        <!-- 气体阈值管理页面 -->
        <div v-if="currentMenu === '3'" class="role-page">
          <VocSetting></VocSetting>
        </div>

        <!-- 用户管理页面 -->
        <div v-if="currentMenu === '4'" class="user-page">
          <User></User>
        </div>

        <!-- 新增通知配置页面 -->
        <div v-if="currentMenu === '5'" class="area-page">
          <MsgSetting></MsgSetting>
        </div>
        <div v-if="currentMenu === '6'" class="area-page">
          <AreaSetting></AreaSetting>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, reactive, computed } from "vue";
import User from "./User.vue";
import Point from "./Point.vue";
import Monitor from "./Monitor.vue";
import VocSetting from "./VocSetting.vue";
import MsgSetting from "./MsgSetting.vue";
import AreaSetting from "./AreaSetting.vue";

import { UserFilled } from "@element-plus/icons-vue";

// 当前选中的菜单
const currentMenu = ref("1");

// 菜单标题映射（新增通知配置）
const currentTitle = computed(() => {
  const titleMap = {
    1: "人脸库管理",
    2: "设备管理",
    3: "气体阈值管理",
    4: "用户管理",
    5: "通知配置", // 新增
    6: "区域管理", // 新增
  };
  return titleMap[currentMenu.value];
});
const handleMenuSelect = (key) => {
  currentMenu.value = key;
};
// 加载状态
const loading = ref(false);
</script>

<style lang="scss" scoped>
// 原有样式不变
.admin-layout {
  height: 100%;
  background-color: #0a1020;
  color: #e5e9f0;

  .sidebar {
    width: 200px;
    background: linear-gradient(180deg, #0f1a30 0%, #050b1a 100%);
    border-right: 1px solid #1a3a6a;
    display: flex;
    flex-direction: column;

    .sidebar-logo {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #1a3a6a;
      padding: 0 15px;

      .logo-icon {
        font-size: 24px;
        color: #00ccff;
        margin-right: 8px;
      }

      .logo-text {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        text-shadow: 0 0 10px rgba(0, 204, 255, 0.3);
      }
    }
    .el-menu {
      border-right: none;
    }
    .sidebar-menu {
      flex: 1;
      padding-top: 20px;

      :deep(.el-menu-item) {
        color: #b0c8e8;
        height: 48px;
        line-height: 48px;
        margin: 0 10px 5px;
        border-radius: 6px;
        padding-left: 20px !important;
        transition: all 0.3s ease;

        &:hover {
          background-color: rgba(0, 204, 255, 0.05);
          color: #00ccff;
        }

        &.is-active {
          background: linear-gradient(135deg, #0066cc 0%, #0099ff 100%);
          color: #ffffff !important;
          box-shadow: 0 0 10px rgba(0, 153, 255, 0.2);
        }
      }

      :deep(.el-menu-item-icon) {
        color: inherit;
        margin-right: 10px;
      }
    }
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;

    .content-header {
      height: 60px;
      background-color: #0f1a30;
      border-bottom: 1px solid #1a3a6a;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .content-title {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        margin: 0;
      }

      .content-actions {
        display: flex;
        gap: 10px;
      }
    }

    .content-body {
      flex: 1;
      padding: 20px;
      overflow: auto;
      background-color: #0a1020;
    }
  }
}
</style>
